import {
  DELETE_HISTORY,
  DELETE_HISTORY_SONG,
  DELETE_PLAYLIST_SONG,
  GET_FAVORITE_SONGS,
  GET_HISTORY,
  GET_PLAYLIST,
  REMOVE_FAVORITE_SONG,
  TOGGLE_FAVORITE_SONG,
} from './actions';
import { PUT_PLAYLISTS } from '../users/actions';

const initialState = {
  /**
   * The current playlist loaded
   */
  current: {
    songs: [],
  },

  /**
   * The favorite songs for the current user
   */
  favorites: [],

  /**
   * The history songs for the current user
   */
  history: [],
};

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case GET_PLAYLIST.REQUEST:
      return {
        ...state,
        current: initialState.current,
      };
    case GET_PLAYLIST.SUCCESS:
      return {
        ...state,
        current: action.payload.playlist,
      };
    case PUT_PLAYLISTS.SUCCESS: 
      return {
        ...state,
        current: {
          ...state.current,
          ...action.payload.playlist,
        }
      };
    case DELETE_PLAYLIST_SONG.SUCCESS: 
      return {
        ...state,
        current: {
          ...state.current,
          songs: state.current.songs.filter(song => song.id !== action.data.song.id),
        }
      };
    case GET_FAVORITE_SONGS.SUCCESS:
      return {
        ...state,
        favorites: action.payload.favorites,
      };
    case GET_HISTORY.SUCCESS:
      return {
        ...state,
        history: action.payload.history,
      };
    case DELETE_HISTORY.SUCCESS:
      return {
        ...state,
        history: [],
      };
    case DELETE_HISTORY_SONG.SUCCESS:
      return {
        ...state,
        history: state.history.filter((sng) => sng.activityId !== action.payload.activity.id),
      };
    case REMOVE_FAVORITE_SONG:
      return {
        ...state,
        favorites: state.favorites.filter((sng) => sng.id !== action.payload.song.id),
      };
    case TOGGLE_FAVORITE_SONG: {
      const name = action.payload.playlist;
      const list = state[name];
      if (list) {
        return {
          ...state,
          [name]: list.map((sng) => {
            if (sng.id === action.payload.song.id) {
              return {
                ...sng,
                isFavorite: !sng.isFavorite,
              };
            }
            return sng;
          }),
        };
      }
    }
    default:
      return state;
  }
}
